import { ResourceProps } from "react-admin";
import Icon from "@mui/icons-material/NightShelter";
import { Resource } from "../../enums";
import ListScreen from "./list";
import { EditScreen } from "./edit";

const privacyPolicyPages: ResourceProps = {
  name: Resource.PRIVACY_POLICY,
  icon: Icon,
  list: ListScreen,
  edit: EditScreen,
  options: {
    label: "Privacy Policy",
  },
};

export default privacyPolicyPages;
